import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/usr/src/app/packages/administration_next/src/app/[locale]/providers.tsx");
